import Breadcrumbs from "@/components/Breadcrumbs";
import { getHrefFromCustomUrlPlugin } from "@/helpers";
import { BuilderBlockProps } from "@/types";
import { Link } from "@/types/General";
import { FC } from "react";

type BreadcrumbsBlockProps = {
  links: Partial<Link>[];
  homeLink?: Partial<Link>;
} & BuilderBlockProps;

export const BreadcrumbsBlock: FC<BreadcrumbsBlockProps> = ({
  homeLink,
  links,
  attributes,
}) => (
  <Breadcrumbs
    {...attributes}
    homeLink={
      homeLink
        ? {
            ...homeLink,
            href: homeLink.href
              ? getHrefFromCustomUrlPlugin(homeLink.href)
              : undefined,
          }
        : undefined
    }
    links={links.map((link) => ({
      ...link,
      href: link.href ? getHrefFromCustomUrlPlugin(link.href) : undefined,
    }))}
  />
);
